'use strict';
import angular from 'angular';
import moment from 'moment';

export default class QuestionsController {
  /*@ngInject*/
  constructor($stateParams, $location, $timeout, $http, $state, $scope, Borne, appConfig) {
    var vm = this;
    var iterator = 0
    vm.loading = true
    vm.end = false
    vm.attemptCount = 0
    vm.availableImages = ['jpg', 'png']
    vm.availableVideos = ['mp3', 'mp4', 'mkv']
    vm.electron = window.electron
    $('.modal-backdrop').hide()

    if(!Borne.Poste) {
      Borne.load($stateParams.borneId).then(function () {
        initPage()
      	$scope.$apply()
      })
    } else {
      initPage()
    }

    function initPage() {
      console.log(Borne.Poste)
      Borne.Poste.questions = {
        correctAnswerCount : 0
      }

      Borne.Poste.Session.questions = {}
      Borne.Poste.Session.questions.badAnwsers = []
      vm.borne = Borne.Poste
      vm.categorie = _.find(Borne.Poste.Categories, ['_id', $stateParams.id])
      vm.formation = angular.copy(_.find(vm.categorie.Formations, ['active', true]))
      setMedia()
      console.log(vm.currentQuestionLangue.reponses)
    }

    vm.restart = function() {
      $('#restartModal').modal('hide')
      iterator =0
      vm.formation = angular.copy(_.find(vm.categorie.Formations, ['active', true]))
      setMedia()
    }

    vm.selectAnswer = function(reponse) {
      if(vm.isAnswered()) return
      if(!reponse.answered) reponse.answered = 1
      else reponse.answered ++
      if(reponse.correcte) {
        Borne.Poste.questions.correctAnswerCount +=1
      } else {
        if(_.find(Borne.Poste.Session.questions.badAnwsers, {question :vm.currentQuestion.name, reponse : reponse.reponse})) _.find(Borne.Poste.Session.questions.badAnwsers, {question :vm.currentQuestion.name}).number ++
        else Borne.Poste.Session.questions.badAnwsers.push({question :vm.currentQuestion.name, reponse : reponse.reponse, number : 1})
      }
      reponse.selected = true
    }

    vm.fitToMedia = function() {
      if(vm.currentQuestion && vm.currentQuestion.media) return 'col-md-6'
      else return 'col-md-12 text-center'
    }

    vm.isAnswered = function(){
      if(_.find(vm.currentQuestionLangue.reponses, ['selected', true])) return true
      else return false
    }

    vm.suivant = function() {
      if(iterator < vm.formation.questions.length -1) {
        iterator++
        setMedia()
      } else {
        if(Borne.Poste.questions.correctAnswerCount >= vm.formation.goodAnwserCount) {
          if(vm.electron){
            $('#validateModal').modal('show')
          } else {
            $('#printModal').modal('show')
          }
        }
        else if((Borne.Poste.questions.correctAnswerCount < vm.formation.goodAnwserCount) && vm.attemptCount < 2) {
          $('#restartModal').modal('show')
          Borne.Poste.questions.correctAnswerCount = 0
          vm.attemptCount++
        }
        else if((Borne.Poste.questions.correctAnswerCount < vm.formation.goodAnwserCount) && vm.attemptCount == 2) {
          $http.get(`api/categories/alert/fail/${vm.categorie._id}`).then(function(resp){
            console.log(resp)
          })
          $('#restartModal').modal('show')
        }
      }
    }

    vm.next = function() {
      if(vm.electron){
        $('#validateModal').modal('hide');
        setTimeout(function(){
          $location.path('/borne_badge/' + vm.categorie._id + '/' + $stateParams.borneId);
          $scope.$apply();
        },250)
      } else {
        $('#printModal').modal('hide');
        vm.borne.collecte.createdAt = moment(new Date).format('DD/MM/YYYY H:mm');
        vm.borne.collecte.expiryDate = moment().add(vm.categorie.expiryDate, 'd').format('DD/MM/YYYY H:mm');
        vm.borne.collecte.session = Borne.Poste.Session.questions;
        $http.get(`api/categories/alert/download/${vm.categorie._id}`);
        $http.post('/api/qr-codes/printQrcode', vm.borne.collecte).then(function(resp){
          var popup = window.open();
          popup.document.write(resp.data.html);
          $timeout(function(){
            popup.print();
            popup.close();
            vm.borne.returnToMain();
          },250)
        })
      }
    }

    function setMedia(){
      vm.currentQuestion = vm.formation.questions[iterator];
      vm.currentQuestionLangue = vm.currentQuestion.langues[vm.currentQuestion.langues.indexOf(_.find(vm.currentQuestion.langues, ['langueId', vm.borne.Langue.id]))];
      vm.source = `${appConfig.baseUrl}/public/postes/${vm.formation._id}/questions/${vm.currentQuestion.media}`;
      if(vm.currentQuestion.media && vm.availableImages.includes(vm.currentQuestion.media.slice(vm.currentQuestion.media.lastIndexOf('.') +1))) vm.end = true;
      vm.currentQuestionLangue.reponses = shuffle(vm.currentQuestionLangue.reponses);
      document.getElementById("supportVideo").src = vm.source
    }

    function shuffle(array) {
      var currentIndex = array.length, temporaryValue, randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/borne/questions/questions.controller.js